import {Validators} from '@angular/forms';

import {ColorCodesEnum, ComponentTypesEnum} from '../../app/shared/enums/common';
import {AutocompleteControl, CheckboxControl, RadioGroupControl} from '../../app/shared/classes';

import {TradingAccountTypesEnum} from '../../app/entries/panel/enums';
import {InArrayValidator} from '@spa/validators';

export interface AssignClientAccountRightsFormInterface {
    type: RadioGroupControl;
    selectableEntity: AutocompleteControl;
    rights: CheckboxControl[];
}

export const AssignClientAccountRightsTypeSelector = 'accountType';
export const AssignClientAccountRightsAccountOrUserSelector = 'account';

export const AssignClientAccountRightsArraySelector = 'accessRightsArray';

export const AssignClientAccountRightsLabel = 'At least one permission';

export const AssignClientAccountRightsFormItems = (accountType: number, initForAccount = false): AssignClientAccountRightsFormInterface => {
    return {
        type: new RadioGroupControl({
            name: AssignClientAccountRightsTypeSelector,
            value: accountType,
            placeholder: 'Account Type',
            validators: [
                Validators.required,
                InArrayValidator([TradingAccountTypesEnum.Trading, TradingAccountTypesEnum.Cash])
            ],
            componentType: ComponentTypesEnum.RadioGroup,
            invalid: false,
            errors: [],
            options: [
                {
                    label: 'Trading Account',
                    value: TradingAccountTypesEnum.Trading,
                    color: ColorCodesEnum.Primary,
                    checked: (accountType === TradingAccountTypesEnum.Trading)
                },
                {
                    label: 'Cash Account',
                    value: TradingAccountTypesEnum.Cash,
                    color: ColorCodesEnum.Primary,
                    checked: (accountType === TradingAccountTypesEnum.Cash)
                }
            ]
        }),
        selectableEntity: new AutocompleteControl({
            name: AssignClientAccountRightsAccountOrUserSelector,
            value: null,
            placeholder: !initForAccount ? 'Account' : 'Client',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Autocomplete,
            options: []
        }),
        rights: []
    };
};
